import ReactMarkdown from 'react-markdown';
import React from 'react';
import { Typography } from '@mui/material';

const Markdown = (props) => {
    const { children } = props;

    return (
        <ReactMarkdown
            components={{
                p: ({ node, ...props }) => <Typography {...props} />,
                em: ({ node, ...props }) => (
                    <Typography
                        component="span"
                        sx={{ color: (theme) => theme.palette.primary.main, fontStyle: 'italic', fontWeight: 550 }}
                        {...props}
                    />
                ),
                strong: ({ node, ...props }) => (
                    <Typography
                        component="span"
                        sx={{ color: (theme) => theme.palette.grey.header, fontWeight: 550 }}
                        {...props}
                    />
                ),
            }}
        >
            {children}
        </ReactMarkdown>
    );
};

export default Markdown;
